export default __webpack_public_path__ + "static/stage-2_5-8009322653c86c760fc40f239fab0869.jpg";